import { SvgIcon } from '@mui/material';

interface VideoCameraIconProps {
  videoEnabled?: boolean;
  /**
   * Hex color for the icon; Default is #F7F7F7
   */
  color?: string;
}

function VideoCameraIcon({
  videoEnabled,
  color = '#F7F7F7',
}: VideoCameraIconProps) {
  return (
    <SvgIcon>
      {videoEnabled ? (
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M23.6034 6.84375C23.4838 6.77964 23.3491 6.74919 23.2135 6.75563C23.078 6.76207 22.9467 6.80516 22.8337 6.88031L19.5 9.09844V6.75C19.5 6.35218 19.342 5.97064 19.0607 5.68934C18.7794 5.40804 18.3978 5.25 18 5.25H3C2.60218 5.25 2.22064 5.40804 1.93934 5.68934C1.65804 5.97064 1.5 6.35218 1.5 6.75V17.25C1.5 17.6478 1.65804 18.0294 1.93934 18.3107C2.22064 18.592 2.60218 18.75 3 18.75H18C18.3978 18.75 18.7794 18.592 19.0607 18.3107C19.342 18.0294 19.5 17.6478 19.5 17.25V14.9062L22.8337 17.1291C22.9576 17.2095 23.1024 17.2515 23.25 17.25C23.4489 17.25 23.6397 17.171 23.7803 17.0303C23.921 16.8897 24 16.6989 24 16.5V7.5C23.9991 7.36506 23.9617 7.23287 23.8919 7.11737C23.8221 7.00187 23.7225 6.90734 23.6034 6.84375ZM18 17.25H3V6.75H18V17.25ZM22.5 15.0984L19.5 13.0988V10.9012L22.5 8.90625V15.0984Z'
            fill={color}
          />
        </svg>
      ) : (
        <svg
          width='25'
          height='24'
          viewBox='0 0 25 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_10473_1181)'>
            <path
              d='M19.25 10.5L23.75 7.5V16.5L19.25 13.5'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M11.0996 6H18.5002C18.6991 6 18.8899 6.07902 19.0306 6.21967C19.1712 6.36032 19.2502 6.55109 19.2502 6.75V14.9653'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M17.9544 18H3.5C3.30109 18 3.11032 17.921 2.96967 17.7803C2.82902 17.6397 2.75 17.4489 2.75 17.25V6.75C2.75 6.55109 2.82902 6.36032 2.96967 6.21967C3.11032 6.07902 3.30109 6 3.5 6H7.04562'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M5 3.75L20 20.25'
              stroke='#F83B3B'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_10473_1181'>
              <rect
                width='24'
                height='24'
                fill='white'
                transform='translate(0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      )}
    </SvgIcon>
  );
}
export default VideoCameraIcon;
